import styles from './styles/HouseManagerProfile.module.css';
import useReviews from './hooks/useReviews';
import useProfileData from './hooks/useProfileData';

export default function ReviewsForm() {
    const { handleReviewsSubmit, newReviews, setNewReviews, newRating, setNewRating } = useReviews();
    const { profile } = useProfileData();
    return (
        <div className={styles.reviewForm}>
                    <div>
                    <h3>Leave {profile?.first_name} a Review </h3>
                    </div>
                    <div className={styles.reviewFormInputs}>
                    <textarea
                        value={newReviews}
                        onChange={(e)=> setNewReviews(e.target.value)}
                        placeholder="Write your review"
                        className={styles.reviewInput}
                    />
                    <input
                        type="number"
                        min='1'
                        max='5'
                        value={newRating}
                        onChange={(e) => setNewRating(Number(e.target.value))}
                        className={styles.reviewInput}
                        placeholder="min 1 and max 5"
                    />
                    <button 
                        className={styles.submitButton} 
                        onClick={handleReviewsSubmit}>
                        Submit Review
                    </button>
                    </div>
                </div>
    )
}